import React, { useContext, useEffect } from 'react'
import style from './header.mod.scss'
import { Menu, Logo, Button } from '@components'
import { Link } from 'gatsby'
import BarsSvg from '@svgs/bars.svg'
import CloseSvg from '@svgs/close.svg'
import SearchSvg from '@svgs/search.svg'
import MyHealthSvg from '@svgs/my-health.svg'
import Arrow from '@svgs/arrow-right.svg'
import ThemeContext from '@context/themeContext'
import SearchContext from '@context/searchContext'

const Header = ({
  menuItems,
  wecareMenuItems,
  modifiers = [],
  isWecareNowPage,
  globalCtas
}) => {
  const { toggleSidebar, isSidebarOpen, isWeCareNow } = useContext(ThemeContext)
  const { setIsSearchModalOpen } = useContext(SearchContext)

  console.log('globalCtas', globalCtas)

  isWecareNowPage && modifiers.push([style['header--wecare-now']])

  return (
    <header className={[style.header, ...modifiers].join(' ')}>
      <div className={style.header__container}>
        <div className={style.header__wrapper}>
          <div className={style.header__upper}>
            <div className={style.header__logo}>
              <Logo colour={'primary'} type={'default'} />
            </div>
            <div className={style.header__menu}>
              <Menu items={menuItems} />
            </div>
            <div className={style.header__buttons}>
              <HeaderButtons globalCtas={globalCtas} />
            </div>
            <div className={style.header__controls}>
              <div className={style.header__search}>
                <button
                  onClick={() => setIsSearchModalOpen(true)}
                  aria-label={'Toggle Search'}
                >
                  <SearchSvg />
                </button>
              </div>
              <ManageMyHealth globalCtas={globalCtas} />
              {isSidebarOpen ? (
                <div className={style.header__close}>
                  <button onClick={toggleSidebar} aria-label={'Toggle Menu'}>
                    <CloseSvg />
                  </button>
                </div>
              ) : (
                <div className={style.header__bars}>
                  <button onClick={toggleSidebar} aria-label={'Toggle Menu'}>
                    <BarsSvg />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

const ManageMyHealth = ({ globalCtas }) => {
  const { showManageMyHealth, manageMyHealthLink } = globalCtas
  const to = manageMyHealthLink?.link?.path || manageMyHealthLink?.url

  if (!showManageMyHealth || !to) return null

  const label = manageMyHealthLink.displayText || 'Manage My Health'

  return (
    <div className={style['header__manage-my-health']}>
      {to.startsWith('http') ? (
        <a
          href={to}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
        >
          <MyHealthSvg />
        </a>
      ) : (
        <Link to={to} aria-label={label}>
          <MyHealthSvg />
        </Link>
      )}
    </div>
  )
}

const HeaderButtons = ({ globalCtas }) => {
  return (
    <>
      <div className={style.header__buttons_desktop}>
        {globalCtas.callToActionButtons.map(cta => (
          <Button
            key={cta.id}
            size={'small'}
            length={'small'}
            icon={cta.icon ? cta.icon : null}
            to={cta?.link?.link?.path || cta?.link?.url}
            buttonStyle={cta.buttonStyle === 'primary' ? 'primary' : ''}
            color={cta.buttonStyle === 'primary' ? 'solid' : ''}
          >
            {cta?.link?.displayText}
          </Button>
        ))}
      </div>
    </>
  )
}

export default Header
